module.exports = __webpack_public_path__ + "files/b56758779acc61c6058c7d386df9da52.svg";